import { useEffect, useRef } from "react";
import crypto from "crypto-js";
import PropTypes from "prop-types";
import Axios from "axios";
import { BASE_URL } from "../../config/config";
import { useNavigate } from "react-router";

// Function to load script and append in DOM tree.
const loadScript = (src) =>
    new Promise((resolve) => {
        const script = document.createElement("script");
        script.src = src;
        script.onload = () => {
            console.log("razorpay loaded successfully");
            resolve(true);
        };
        script.onerror = () => {
            console.log("error in loading razorpay");
            resolve(false);
        };
        document.body.appendChild(script);
    }); 

    
    const RenderRazorpay = ({
        orderId,
        keyId,
        keySecret,
        currency,
        amount,
        handleSubmit,
    setRazorIntentId,
    companyName = "",
}) => {
    const paymentId = useRef(null);
    const paymentMethod = useRef(null);
    const rzpInstance = useRef(null);
    const navigate = useNavigate()

    const options = {
        key: keyId, // key id from props
        amount: `${amount}`, // Amount in lowest denomination from props
        currency, // Currency from props.
        name: companyName, // Title for your organization to display in checkout modal
        // image, // custom logo  url
        order_id: orderId, // order id from props
        handler: (response) => {
            console.log("succeeded");
            console.log(response);
            paymentId.current = response.razorpay_payment_id;

            const succeeded =
                crypto
                    .HmacSHA256(
                        `${orderId}|${response.razorpay_payment_id}`,
                        keySecret
                    )
                    .toString() === response.razorpay_signature;

            if (succeeded) {
                handlePayment("succeeded", { 
                    orderId,
                    paymentId,
                    signature: response.razorpay_signature,
                });
                setRazorIntentId("");
                if (rzpInstance.current) {
                    rzpInstance.current.close();
                    let razoeElement =
                        document.getElementsByClassName("razorpay-container");
                    if (razoeElement) {
                        while (razoeElement.length > 0) {
                            razoeElement[0].parentNode.removeChild(
                                razoeElement[0]
                            );
                        }
                    }
                    // Restore scrolling
                    document.body.style.overflow = "auto";
                }
            } else {
                handlePayment("failed", {
                    orderId,
                    paymentId: response.razorpay_payment_id,
                });
            }
        },
        modal: {
            confirm_close: true,
            ondismiss: async (reason) => {
                const {
                    reason: paymentReason, 
                    field,
                    step,
                    code,
                } = reason && reason.error ? reason.error : {};
                if (reason === undefined) {
                    console.log("cancelled");
                    handlePayment("Cancelled");
                } else if (reason === "timeout") {
                    console.log("timedout");
                    handlePayment("timedout");
                } else {
                    console.log("failed");
                    handlePayment("failed", {
                        paymentReason,
                        field,
                        step,
                        code,
                    });
                }
                // Restore scrolling
                document.body.style.overflow = "auto";
            },
        },
        retry: {
            enabled: false,
        },
        timeout: 900,
        theme: {
            color: "", // Custom color for your checkout modal.
        },
    };

    const displayRazorpay = async (options) => {
        const res = await loadScript(
            "https://checkout.razorpay.com/v1/checkout.js"
        );

        if (!res) {
            console.log("Razorpay SDK failed to load. Are you online?");
            return;
        }
        const rzp1 = new window.Razorpay(options);
        rzpInstance.current = rzp1;
        rzp1.on("payment.submit", (response) => {
            paymentMethod.current = response.method;
        });

        rzp1.on("payment.failed", (response) => {
            paymentId.current = response.error.metadata.payment_id;
        });

        // Disable scrolling while the Razorpay modal is open
        document.body.style.overflow = "hidden";

        rzp1.open();
    };

    const handlePayment = async (status, orderDetails = {}) => {
        if (status === "succeeded") {
            handleSubmit(
                undefined,
                orderDetails?.paymentId?.current,
                "razorpay",
                orderDetails
            );
        }
        console.log("status:", status, "orderDetails", orderDetails);
    };

    useEffect(() => {
        console.log("in razorpay");
        displayRazorpay(options);

        // Cleanup function to restore scroll
        return () => {
            document.body.style.overflow = "auto";
        };
    }, []);

    return null;
};

RenderRazorpay.propTypes = {
    orderId: PropTypes.string.isRequired,
    keyId: PropTypes.string.isRequired,
    keySecret: PropTypes.string.isRequired,
    currency: PropTypes.string.isRequired,
    amount: PropTypes.number.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    setRazorIntentId: PropTypes.func.isRequired,
    companyName: PropTypes.string,
};

export default RenderRazorpay;
